import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import * as auth from './modules/auth'
import * as comenzi from './modules/comenzi'
import * as intrareNouaV2 from './modules/intrareNouaV2'
import * as clienti from './modules/clienti'
import * as facturi from './modules/facturi'
import * as setari from './modules/setari'
import * as haynes from './modules/haynes'
import * as templates from './modules/templates'
import * as programari from './modules/programari'
import * as devize from './modules/devize'
import * as links from './modules/links'
import * as error_reporter from './modules/error_reporter'
import * as replay_recorder from './modules/replay_recorder'
import * as analytics from './modules/analytics'
import api from './api'
import { languages } from './language'
Vue.use(Vuex)

export const state = {
  lang: localStorage.getItem('language') || 'ro',
  template: {
    formularComanda: {
      fields: [],
      pieseClient: '',
      alteDefecte: '',
      valoareEstimativa: '',
      termen: ''
    }
  },
  isModal: false,
  trial_expired_modal: false,
  subscription_expired_modal: false,
  in_progress_server_request_name: '',
  languages: [
    { key: 'ro', title: 'RO' },
    { key: 'se', title: 'SE' },
  ],
}

export const mutations = {
  SET_MODAL (state, data) {
    state.isModal = data;
  },
  SET_TRIAL_EXPIRED_MODAL (state, value) {
    state.trial_expired_modal = value;
  },
  SET_SUBSCRIPTION_EXPIRED_MODAL (state, value) {
    state.subscription_expired_modal = value;
  },
  SET_KEY_VALUE (state, { key, sub, value }) {
    sub
      ? Vue.set(state[sub], key, value)
      : Vue.set(state, key, value)
  },
  SET_REQ_IN_PROGRESS_NAME (state, value) {
    state.in_progress_server_request_name = value;
  }
}

export const actions = {
  async post_slack_message (_, payload) {
    await axios.post(api.slack_message, payload)
  }
}

const store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters: {
    lang: state => languages[state.lang],
    months: state => languages[state.lang].months,
    days: state => languages[state.lang].days,
    isSettingsLoading: state => state.setari.isLoadingSettings,
    isSettingsDirty: state => (
      state.setari.settingsSnapshot !== null &&
      JSON.stringify(state.setari.settings) !== state.setari.settingsSnapshot
    ),
    isSettingsInvalid: state => state.setari.hasFieldErrors,
  },
  modules: {
    auth,
    programari,
    comenzi,
    intrareNouaV2,
    clienti,
    facturi,
    setari,
    haynes,
    templates,
    links,
    devize,
    error_reporter,
    replay_recorder,
    analytics
  }
})

export default store
